module.exports = __webpack_public_path__ + "img/pc_footer_img.ee426ba.webp";